import React from 'react';
import {Text, View} from 'react-native';
import AVText from '../../AVText';
import AVFormattedCurrency from '../../AVFormattedCurrency';
import {RecentOrderItemModifierType} from 'src/types/RecentOrders';
import {WithLocalizedProps} from 'src/types/PropTypes';
import AccountStore from 'src/stores/AccountStore';
import Styles from 'src/components/Styles';
import {styles} from './recentOrderStyles';

type RecentOrderItemModifierProps = WithLocalizedProps & {
  modifier: RecentOrderItemModifierType;
};

const RecentOrderItemModifier: React.FC<RecentOrderItemModifierProps> = ({
  modifier,
  strings,
}) => {
  let label;

  if (true) {
    label = (
      <AVText>
        {'('}
        <AVText style={{color: '#138665'}}>
          {'+'}
          <AVFormattedCurrency
            accessible={true}
            accessibilityLabel={`${strings.Labels.price}: $${modifier.price}`}
            aria-lable={`${strings.Labels.price}: $${modifier.price}`}
            style={[styles.modifierText, styles.modifierPrice]}
            value={modifier.price || 0}
            currency={AccountStore.getCurrency()}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm3}
          />
        </AVText>
        {')'}
      </AVText>
    );
  }
  return (
    <View style={styles.modifierContainer}>
      <Text
        style={styles.modifierText}
        numberOfLines={5}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm3}
      >
        {modifier.name?.substring(0, 30) + ' '}
        {label}
      </Text>
    </View>
  );
};

export default RecentOrderItemModifier;
